const APP_CONFIG = {
    IS_UPLOAD_MULTI: true,
    IMAGE: {
        "LOGO": "images/logo.svg",
        "LOGO_MOBILE": "images/logo_mobile.svg",
        "DEFAULT_USER": "images/default_user.svg",
    },

    // 통신
    COMMUNICATION: {
        METHOD: "",
        POLLING: {
            INTERVAL: 1000,
        },
        SSE: {
            DOMAIN: ""
        }
    },
    COMMUNICATION_DATE_FORMAT: "YYYYMMDD",
    COMMUNICATION_TIME_FORMAT: null,   // null is "millisecond" or "unix"

    // 기능 - 아이디 타입
    ACCOUNT: {
        ID_TYPE: "",            // id or email
        PASSWORD_REQUIRE: {
            ENABLE: true,
            IS_ALPHABET: true,
            IS_NUMBER: true,
            IS_SPECIAL_CHARACTERS: true,
            IS_NEED_LENGTH: 8,
        },
    },

    // 조직도 설정
    SSO_ORGANIZATION: false,

    // 기능 - 업로드 사이즈
    MAX_UPLOAD_SIZE: 30,
    SUPPORT_FORMAT_LIST: ["PDF"],

    // 기능 - 업로드 사이즈
    MAX_DOC_ATTACHMENT_UPLOAD_SIZE: 30,
    SUPPORT_DOC_ATTACHMENT_FORMAT_LIST: null,

    // 기능 - 업로드 사이즈
    PROFILE_MAX_UPLOAD_SIZE: 10,
    PROFILE_SUPPORT_FORMAT_LIST: ["PNG", "JPG", "JPEG"],

    // 기능 - Excel 업로드
    EXCEL_MAX_UPLOAD_SIZE: 10,
    EXCEL_SUPPORT_FORMAT_LIST: ["XLSX"],

    // 라벨 색상
    LABEL_COLOR_LIST: [
        "#90B5E9",
        "#FFA114",
        "#F917DA",
        "#D3DC61",
        "#39BADA",
        "#4567E5",
        "#8433F7",
        "#E45F81",
        "#FF9020",
        "#5BD3B3",
        "#1D607A",
        "#4D5661",
        "#83654C",
        "#66C568",
        "#BD87E9",
        "#661100",
        "#5C2CE5",
        "#004BA6",
        "#270A33",
        "#1D8D74",
    ],
    DEFAULT_LABEL_COLOR: "#959BA6",

    // 인장 설정
    SIGNATURE_MAX_UPLOAD_SIZE: 10,
    SIGNATURE_SUPPORT_FORMAT_LIST: ["PNG", "JPG"],
    SIGNATURE_DRAWING_MODE: "signaturePad", // "signaturePad" or sketchCanvas
    SIGNATURE_PAD_MIN_WIDTH: 0.5,
    SIGNATURE_PAD_MAX_WIDTH: 2.5,
    SIGNATURE_PAD_PEN_COLOR: 'black',
    SIGNATURE_PAD_MIN_DISTANCE: 3,


    INTO_MODULE_OPTION: {
        // UI 설정
        defaultScaleValue: "auto",                // "auto" | "page-fit" | "page-width" | number
        enableBottomControls: true,               // 하단 컨트롤(페이지 이동, 줌) 표시 여부
        bottomControlsAutoHide: true,             // 하단 컨트롤 자동 숨김 여부

        // 참여자 설정
        enableParticipant: true,                  // 참여자 패널 표시 여부
        enableDisplayParticipantLabel: true,      // 필드에 참여자 색상 표시

        // 필드 설정
        disableDefaultFieldColor: false,            // 기본 필드 색상 비활성화 여부
        enableIsReadOnly: true,                     // 필드 "수정 불가" 속성 사용 여부
        enableIsHidden: true,                       // 필드 "숨김" 속성 사용 여부
        enableIsDeIdentified: true,                 // 필드 "비식별화" 속성 사용 여부
        enableIsExtract: true,                     // 필드 "값 추출" 속성 사용 여부
        enableIsEncrypted: false,                   // 필드 "암호화" 속성 사용 여부
        enableIsRefExternal: false,                 // 외부 참조 데이터 사용 여부(사용안함)

        // 필드 속성 패널 표시 여부
        enableFieldOption: false,                 // 필드 옵션 (활성화 조건/유효성 검사) 패널 표시 여부
        enableFieldRequired: false,               // 필드 필수 여부 (입력 여부) 패널 표시 여부
        enableFieldAttrOption: true,              // 필드 속성 옵션 (숨김/비식별화/암호화/추출) 패널 표시 여부

        // 사용 가능한 필드 타입 목록 (빈 배열이면 모든 필드 타입 사용 가능)
        // 필드 타입: "sign", "stamp", "text", "dropdown", "checkbox", "radio", "handwrite", "formula", "injang", "blackbox-mask"
        fieldList: [],

        // 커스텀 속성
        enableCustomAttr: true,                   // 커스텀 속성 패널 표시 여부 (customId 수동 편집)
        isAutoCustomId: true,                     // 필드 생성 시 customId 자동 생성 여부

        // 블랙박스 마스킹
        enableBlackboxMask: true,                 // 마스킹 필드 추가 버튼 표시 여부
        showBlackboxMask: true,                   // 마스킹 필드 렌더링 표시 여부

        // 인장 설정
        injangShowImage: false,                    // 인장 이미지 표시 여부 (false이면 인장 이름만 표시)
        injangSyncSize: true,                     // 모든 인장 필드 크기 동기화 여부
    },

    // 문서 뷰어 전용 모듈 옵션 (ModalDocWorkflow, ModalDocView 등에서 사용)
    INTO_MODULE_OPTION_VIEW: {
        // UI 설정
        defaultScaleValue: 'page-width',
        enableBottomControls: true,               // 하단 컨트롤(페이지 이동, 줌) 표시 여부
        bottomControlsAutoHide: true,             // 하단 컨트롤 자동 숨김 여부

        // 참여자 설정
        enableParticipant: true,                  // 참여자 기능 활성화
        enableParticipantLabel: true,             // 참여자 라벨 기능 활성화

        // 값만 표시 (색상/별표 등 UI 장식 제거)
        enableDisplayParticipantLabel: false,     // 참여자 라벨 텍스트 숨김
        enableRequiredIndicator: false,           // 필수 별표 아이콘 숨김
        // 필드 색상: 카테고리별 세분화 제어
        //  - default: 일반 입력 필드는 색상 제거
        //  - injang: 인장 필드는 색상 유지 (참여자 식별용)
        //  - reference: 외부 참조 필드는 색상 유지
        enableDisplayFieldColor: {
            default: false,
            injang: true,
            reference: true,
        },

        injangShowImage: false,                    // 인장 이미지 표시 여부 (false이면 인장 이름만 표시)
    },

    INTO_MODULE_EXTERNAL_DOCUMENT_DATA_LIST: [
        "DOCUMENT_ID",
        "DOCUMENT_REQUEST_DATE",
        "DOCUMENT_COMPLETE_DATE",
    ],
    INTO_MODULE_EXTERNAL_PARTICIPANT_DATA_LIST: [
        "PARTICIPANT_NAME",
        "PARTICIPANT_EMAIL",
        "PARTICIPANT_PHONE",
        "PARTICIPANT_CELL_PHONE",
        "PARTICIPANT_BIRTH_DATE",
        "PARTICIPANT_ADDRESS",
        "PARTICIPANT_NUMBER",
        "PARTICIPANT_MEMBER_TYPE",
        "PARTICIPANT_MEMBER_POSITION",
        "PARTICIPANT_MEMBER_RESPONSIBILITY",
        "PARTICIPANT_MEMBER_RANK",
        "PARTICIPANT_MEMBER_DEPARTMENT",
        "PARTICIPANT_JOIN_DATE",
        "PARTICIPANT_QUIT_DATE",
    ],
    // Gateway WAF 우회 모드
    // '': 비활성 (기본값, 기존 직접 전송)
    // 'base64': base64 인코딩만
    // 'gzip+base64': gzip 압축 + base64 인코딩
    GATEWAY_ENABLED: '',

    INTO_MODULE_EXTERNAL_DATA_FORMATS: {
        DATE: {
            // 지원하는 입력 형식
            INPUT: [
                "YYYYMMDD",           // 20240115
                "YYYY-MM-DD",         // 2024-01-15
                "YYYY.MM.DD",         // 2024.01.15
                "YYYY/MM/DD",         // 2024/01/15
                "YYYY년 MM월 DD일",    // 2024년 01월 15일
                "YY-MM-DD",           // 24-01-15 (2자리 연도)
                "YY.MM.DD",           // 24.01.15
                "MM-DD-YYYY",         // 01-15-2024 (미국식)
            ],
            // 출력 형식 옵션
            OUTPUT: [
                {name: "YYYY.MM.DD", value: "YYYY.MM.DD"},
                {name: "YYYY-MM-DD", value: "YYYY-MM-DD"},
                {name: "YYYY년 MM월 DD일", value: "YYYY년 MM월 DD일"},
            ],
        },
        CELL_PHONE: {
            // 지원하는 입력 형식
            INPUT: [
                "00000000000",        // 01012345678 (숫자만)
                "000-0000-0000",      // 010-1234-5678 (하이픈)
                "000.0000.0000",      // 010.1234.5678 (점)
                "000 0000 0000",      // 010 1234 5678 (공백)
                "+82 00 0000 0000",   // +82 10 1234 5678 (국제번호)
                "(000) 0000-0000",    // (010) 1234-5678 (괄호)
            ],
            // 출력 형식 옵션
            OUTPUT: [
                {name: "010-0000-0000", value: "010-0000-0000"},
                {name: "01000000000", value: "01000000000"},
            ],
        },
    },
};
export default APP_CONFIG
